import request from '@/utils/request'
import { getRequest } from "@/utils/postData";

// 轮播图
export function getBanner() {
  var sign = getRequest();
  return request({
    url: '/v5/neocortex/banners',
    method: 'get',
    headers: {
      'X-Signature': sign
    }
  })
}
export function getNeocortexList(params) {
  var sign = getRequest(params);
  return request({
    url: '/v5/neocortex',
    method: 'get',
    params,
    headers: {
      'X-Signature': sign
    }
  })
}
export function getArticles(params) {
  var sign = getRequest(params);
  return request({
    url: '/v5/neocortex/articles',
    method: 'get',
    params,
    headers: {
      'X-Signature': sign
    }
  })
}

export function getArticleDetail(id) {
  var sign = getRequest({});
  return request({
    url: '/v5/articles/' + id,
    method: 'get',
    headers: {
      'X-Signature': sign
    }
  })
}

// 音频首页列表页
export function getRadioList() {
  var sign = getRequest({});
  return request({
    url: '/v4/audio/audio_index',
    method: 'get',
    headers: {
      'X-Signature': sign
    }
  })
}
// 音频-查看音频热门推荐接口
export function getHotRecommendList(params) {
  var sign = getRequest(params);
  return request({
    url: '/v4/audio_series/visits',
    method: 'get',
    params,
    headers: {
      'X-Signature': sign
    }
  })
}

export function getAudioArticlesList(params) {
  var sign = getRequest(params);
  return request({
    url: '/v4/audio/audio_articles',
    method: 'get',
    params: params,
    headers: {
      'X-Signature': sign
    }
  })
}

export function getAudioSeriesList(params) {
  var sign = getRequest(params);
  return request({
    url: '/v4/audio_series',
    method: 'get',
    params: params,
    headers: {
      'X-Signature': sign
    }
  })
}

export function getAudioCommentsList(params) {
  var sign = getRequest(params);
  var id = params.id
  return request({
    url: `/v4/articles/${id}/audio_comments`,
    method: 'get',
    params: params,
    headers: {
      'X-Signature': sign
    }
  })
}

// 获取音频产品信息接口
export function getAudioProduct(params) {
  var sign = getRequest(params)
  return request({
    url: '/v4/article_orders/get_products',
    method: 'get',
    params: params,
    headers: {
      'X-Signature': sign
    }
  })
}

// 获取音频产品信息接口
export function getAudioAtricleOrder(data) {
  var sign = getRequest(data)
  return request({
    url: '/v4/article_orders/pingpp_charge',
    method: 'post',
    data,
    headers: {
      'X-Signature': sign
    }
  })
}
// 获取音频产品信息接口
export function getAudioSerieOrder(data) {
  var sign = getRequest(data)
  return request({
    url: '/v4/audio_orders/pingpp_charge',
    method: 'post',
    data,
    headers: {
      'X-Signature': sign
    }
  })
}

// 获取支付状态
export function getNotifyJs(params, id) {
  var sign = getRequest(params);
  return request({
    url: `/v4/article_orders/${id}`,
    method: 'get',
    params,
    headers: {
      'X-Signature': sign
    }
  })
}

// 获取音频栏目产品回调
// export function getAudioSerieOrder (data) {
//   var sign = getRequest(data)
//   return request({
//     url: '/v4/yicai_pay/audio_series_notify',
//     method: 'post',
//     data,
//     headers: {
//       'X-Signature': sign
//     }
//   })
// }



// WEBPACK FOOTER //
// ./src/api/new.js